module.exports = __webpack_public_path__ + "img/243b26e.png";